import { get } from "lodash";
import serverCall from "../serverCall";

// 2FA (TOTP / Google Authenticator) for the logged-in admin. serverCall attaches the JWT.
const status = async () => {
  const r = await serverCall.get("/auth/2fa/status");
  return get(r, "data.apiresponse.data", false);
};

// Returns { secret, otpauth }.
const setup = async () => {
  const r = await serverCall.post("/auth/2fa/setup");
  return get(r, "data.apiresponse.data", {});
};

const enable = async (code) => serverCall.post("/auth/2fa/enable", { code });

const disable = async (code) => serverCall.post("/auth/2fa/disable", { code });

const TwoFaService = { status, setup, enable, disable };
export default TwoFaService;
